import { CModal, CModalBody, CModalHeader } from '@coreui/react-pro';
import React from 'react';
import Media from './Media';

const PopupReview = ({ visible, setVisible, fileName, src, editInAccordion, isLoading }) => {
     return (
          <CModal
               className={` popupreview ${src.includes('mp4') ? 'selling-video' : ''} `}
               alignment="center"
               visible={visible}
               onClose={() => setVisible(false)}
          >
               <CModalHeader onClose={() => setVisible(false)}></CModalHeader>
               <CModalBody>
                    <Media fileName={fileName} isLoading={isLoading} src={src} editInAccordion={editInAccordion} />
               </CModalBody>
          </CModal>
     );
};

export default PopupReview;
